import { name } from './name';
import { role } from './role';
import { status } from './status';
import { conditions } from './conditions';
import { cpu } from './cpu';
import { memory } from './memory';
import { version } from './version';
import { ip } from './ip';
import { cachedImages } from './cachedImages';
import { getActions } from './actions';

export function getColumns({
  isServerMetricsEnabled,
  isNodeShellEnabled,
  isAdmin,
}: {
  isServerMetricsEnabled: boolean;
  isNodeShellEnabled: boolean;
  isAdmin: boolean;
}) {
  const baseColumns = [
    name,
    role,
    status,
    conditions,
    cpu,
    memory,
    version,
    ip,
    cachedImages,
  ];

  const hasVisibleAction =
    isServerMetricsEnabled || (isNodeShellEnabled && isAdmin);
  if (!hasVisibleAction) {
    return baseColumns;
  }

  return [
    ...baseColumns,
    getActions(isServerMetricsEnabled, isNodeShellEnabled),
  ];
}
